import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import HiringPortal from '../components/HiringPortal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HiringPortalPage = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(`${API}/recruitment/check-access`, config);
        
        if (response.data.has_access) {
          setHasAccess(true);
        } else {
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Error checking access:', error);
        navigate('/dashboard');
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!hasAccess) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header user={user} setUser={setUser} />
      <Navigation user={user} />
      <main className="max-w-screen-2xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <HiringPortal user={user} />
      </main>
    </div>
  );
};

export default HiringPortalPage;
